import Layout from '@/components/layouts'
import Theme from '@/components/template/Theme'
import UpdateElectron from '@/components/update'
import appConfig from '@/configs/app.config'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import globalAxios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // NProgress CSS dosyasını ithal edin

import NiceModal from '@ebay/nice-modal-react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { PersistGate } from 'redux-persist/integration/react'
import { ErrorDetailModal } from './components/ui/ErrorViewer'
import { blobToString } from './components/ui/utils/blobUtil'
import { PERSIST_STORE_NAME } from './constants/app.constant'
import './locales'
import mockServer from './mock'
import store, { persistor } from './store'
import deepParseJson from './utils/deepParseJson'

const environment = process.env.NODE_ENV

/**
 * Set enableMock(Default false) to true at configs/app.config.js
 * If you wish to enable mock api
 */
if (environment !== 'production' && appConfig.enableMock) {
   mockServer({ environment })
}

globalAxios.interceptors.request.use(
   async (config) => {
      NProgress.configure({ showSpinner: false, minimum: 0.35 }).start()

      const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
      const persistData = deepParseJson(rawPersistData)

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let accessToken = (persistData as any).auth.session.token

      config.headers['Authorization'] = 'Bearer ' + accessToken
      return config
   },
   (error) => {
      // NProgress.done()
      return error
   },
)

globalAxios.interceptors.response.use(
   (response) => {
      NProgress.done()

      if (globalAxios.isAxiosError(response)) {
         return Promise.reject(response)
      } else {
         return response
      }
   },
   async (error) => {
      NProgress.done()

      if (error.response.data instanceof Blob && error.response.data.type.includes('application/json')) {
         const data = await blobToString(error.response.data)
         error.response.data = JSON.parse(data)
         return Promise.reject(error)
      } else {
         return Promise.reject(error)
      }
   },
)

const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         refetchOnMount: false,
         refetchOnWindowFocus: false,
         refetchOnReconnect: false,
      },
      mutations: {
         onSuccess(data, variables, context) {
            if (globalAxios.isAxiosError(data)) {
               return Promise.reject(data)
            }
         },
         onError: (response: any, a, b) => {
            NiceModal.show(ErrorDetailModal, { error: response })
            //   if (response?.response?.status === 422 && response?.response?.data?.errors[0]?.code === '422-DAT-001') {
            //     modal.warning({ title: 'Borç Bilgilendirme', width: 1200, content: <BalanceDetail />, className: 'error-viever dynamic-content-modal-empty-footer' });
            //   } else {
            //     modal.error({ title: 'Hata Detayları', width: 600, content: <ErrorViewer error={response} />, className: 'error-viever' });
            //   }
         },
      },
   },
})

function App() {
   return (
      <QueryClientProvider client={queryClient}>
         <RecoilRoot>
            <Provider store={store}>
               <PersistGate loading={null} persistor={persistor}>
                  <BrowserRouter>
                     <NiceModal.Provider>
                        <Theme>
                           <Layout />
                           {__IS_ELECTRON__ && <UpdateElectron />}
                        </Theme>
                     </NiceModal.Provider>
                  </BrowserRouter>
               </PersistGate>
            </Provider>
         </RecoilRoot>
      </QueryClientProvider>
   )
}

export default App
